<!-- <template>
    <div :class="[isOpen ? 'city city-open' : 'city']">
        <div class="city-inner">
            <input class="form-guest-selector  form-control city-selected" :style=customStyle style="padding-left:16px"
                ref="toggle"
                :tabindex="tabindex"
                :value="selectedText"
                :class="customClass"
                @click="onToggle"
                @keydown="onKey"
                :disabled="disabled"
                >
            <transition name="fade" mode="out-in">
                <div class="city-dropdown" v-if="isOpen"  style="height:200px; overflow-y:scroll">
                    <div class="city-input_wrap">
                        <input type="text" class="form-control form-control-sm city-input" autocomplete="off" placeholder="Search..."
                            ref="search" @blur="onBlur"
                            @input="onSearch"
                            @keydown.esc="onEsc"
                            @keydown.up="onUpKey"
                            @keydown.down="onDownKey"
                            @keydown.enter.prevent="onEnterKey">
                    </div>
                    <ul class="city-list" v-if="results.length">
                        <li class="city-item" v-for="(result, index) in results" @mousedown.prevent="select(result)" @mouseover.prevent="onMouse(index)" :class="['city-link', selectIndex === index ? 'city-active':'']" :key="index">
                            {{ result.asset_name }}
                        </li>
                    </ul>
                     <table class="table table-responsive-sm table-bordered table-sm city-list" v-if="results.length">
                        <thead>
                            <tr>

                                <th class="city-link">School Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="city-item" v-for="(result, index) in results" @mousedown.prevent="select(result)" @mouseover.prevent="onMouse(index)" :class="['city-link', selectIndex === index ? 'city-active':'']" :key="index">

                                <td>
                                    {{ result.school_name }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </transition>
        </div>
    </div>
</template>

<style>
    .city {
      position: relative;
      display: block;
      background: transparent;
    }

    .city-open {
      border-bottom: 0;
    }

    .city-open .form-control {
        background: #fff;
        -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
        border: 1px solid #f2f2f2;
    }

    .city-inner {
        position: relative;
    }

    .city-selected {
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        display: -webkit-box !important;
        display: -ms-flexbox !important;
        display: flex !important;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        line-height: 15px;
        /* height:62px; */
    }

    .city-dropdown {
      /* column-width: 100%; */
      /* width: 100%; */
      position: absolute;
      z-index: 999 !important;
      padding: 5px;
      background: #fff;
      border-right: 1px solid #f2f2f2;
      border-left: 1px solid #f2f2f2;
      -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    }

    .city-input {
      line-height: 13px;
      font-size: 13px;
      background: #fafafa;
      border: none;
      border-radius: 1px;
      -webkit-box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.1);
              box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.1);
      padding: 4px 8px;
      width: 100%;
      display: block;
    }

    .city-input:focus {
      outline-style: dotted;
      outline-width: 1px;
      outline-offset: 1px;
    }

    .city-input_wrap {
      position: relative;
    }

    .city-list {
      display: block;
      margin: 0;
      padding: 0;
    }
    .city-item{
        padding:5px!important;
    }

    .city-link {
      cursor: pointer;
      padding: 2px;
      background: #fff;
    }

    .city-active {
      background: #5143d9 !important;
      color: #fff !important;
    }

    .city-list td, th {
        white-space: nowrap;
        overflow: hidden;
        text-overflow:ellipsis;
    }
</style>

<script type="text/javascript">
    export default {
        props: {
            initialize: {
                default: null
            },
            customClass: {
                default: ''
            },
            tabindex: {
                default: 0
            },
            customStyle:{
                default: null
            },
            disabled: {
                type: Boolean,
            },
            district_ids: {
                type: Array,
                default:[]
            }
        },
        data () {
            return {
                timer:null,
                selectIndex: -1,
                isOpen: false,
                search: '',
                results: [],
                query: {
                    search: '',
                    order_by: "asc",
                    keyword: "school_name",
                    per_page: 10,
                    district_ids:[]
                },
                temp:[],
            }
        },
        computed: {
            selectedText() {
                return this.initialize
                    ? this.initialize
                    : 'Select School'
            }
        },
        methods: {
            focus: function () {
                this.$refs.toggle.focus()
            },

            onToggle() {
                if(this.isOpen) {
                    this.isOpen = false
                } else {
                    this.open()
                }

            },
            onKey(e) {
                const KeyCode = e.KeyCode || e.which
                if(!e.shiftKey && KeyCode !== 9 && !this.isOpen) {
                    this.open()
                }
            },
            open() {
                if (this.district_ids.length == 0) {
                    this.close()
                    this.$emit('selectSearch', {
                        target: {
                            value: this.district_ids.length
                        }
                    })
                    this.isOpen = false
                    return
                }
                else {
                    this.$emit('selectSearch', {
                        target: {
                            value: this.district_ids.length
                        }
                    })
                }


                this.fetchData('')
                this.isOpen = true
                this.$nextTick(() => {
                    this.$refs.search.focus()
                })
            },
            fetchData(query) {
                let vm = this;
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    vm.results = [];
                    vm.query.district_ids = vm.district_ids;
                    vm.query.search = query;
                    vm.$store.dispatch('post',{'uri':'school/districtSchool',data: vm.query})
                    .then(function (response) {
                        vm.results = response.data.data.data;
                    });
                }, 250);
            },
            onBlur() {
                this.close()
            },
            onEsc() {
                this.close()
            },
            close() {
                this.results = []
                this.isOpen = false
                this.search = ''
                this.selectIndex = -1
            },
            onSearch(e) {
                const q = e.target.value
                this.selectIndex = 0
                this.fetchData(q)
            },
            onUpKey() {
                if(this.selectIndex > 0) {
                    this.selectIndex--
                }
            },
            onDownKey() {
                if(this.results.length - 1 > this.selectIndex) {
                    this.selectIndex++
                }
            },
            onEnterKey() {
                const found = this.results[this.selectIndex]
                if(found) {
                    this.select(found)
                }
            },
            select(result) {
                this.$emit('selectSchool', {
                    target: {
                        value: result
                    }
                })
                // this.$emit('selectSearch', {
                //     target: {
                //         value: vm.district_ids.length
                //     }
                // })
                this.close()
            },
            onMouse(index) {
                this.selectIndex = index
            }
         }
    }
</script> -->



<template>
    <div :class="[isOpen ? 'city city-open' : 'city']">
        <div class="city-inner">
            <input class="form-guest-selector form-select city-selected" :style=customStyle style="padding-left:16px"
                ref="toggle" 
                :tabindex="tabindex"
                :value="selectedText"
                :class="customClass"
                @click="onToggle"
                @keydown="onKey">
            <transition name="fade" mode="out-in">
                <div class="city-dropdown" v-if="isOpen">
                    <div class="city-input_wrap">
                        <input type="text" class="form-control form-control-sm city-input" autocomplete="off" placeholder="Search..."
                            ref="search" @blur="onBlur"
                            @input="onSearch"
                            @keydown.esc="onEsc"
                            @keydown.up="onUpKey"
                            @keydown.down="onDownKey"
                            @keydown.enter.prevent="onEnterKey">
                    </div>
                    <div class="city-results-scroll" ref="resultsScroll" @scroll="onResultsScroll" @mousedown.prevent>
                        <table class="table table-sm table-bordered city-list" v-if="results.length">
                            <tbody>
                                <tr
                                    class="city-item"
                                    v-for="(result, index) in results"
                                    @mousedown.prevent="select(result)"
                                    @mouseover.prevent="onMouse(index)"
                                    :class="['city-link', selectIndex === index ? 'city-active':'']"
                                    :key="result.school_id || index"
                                >
                                    <td>
                                        {{ schoolLabel(result) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="city-status" v-if="loading">Loading...</div>
                        <div class="city-status" v-else-if="!results.length">No schools found</div>
                        <div class="city-status" v-else-if="!hasMore">End of list</div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<style>
    .city {
      position: relative;
      display: block;
      background: #fff;
    }

    .city-open {
      border-bottom: 0;
    }

    .city-open .form-control {
        background: #fff;
        -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
        border: 1px solid #f2f2f2;
    }

    .city-inner {
        position: relative;
    }

    .city-selected {
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        display: -webkit-box !important;
        display: -ms-flexbox !important;
        display: flex !important;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        line-height: 15px;
    }

    .city-dropdown {
      width: 100%;
      min-width: 280px;
      left: 0;
      position: absolute;
      z-index: 999 !important;
      padding: 5px;
      background: #fff;
      border-right: 1px solid #f2f2f2;
      border-left: 1px solid #f2f2f2;
      -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    }

    .city-results-scroll {
      max-height: 200px;
      overflow-y: auto;
    }

    .city-status {
      padding: 8px;
      font-size: 12px;
      color: #6c757d;
      text-align: center;
    }

    .city-input {
      line-height: 13px;
      font-size: 13px;
      background: #fafafa;
      border: none;
      border-radius: 1px;
      -webkit-box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.1);
              box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.1);
      padding: 4px 8px;
      width: 100%;
      display: block;
    }

    .city-input:focus {
      outline-style: dotted;
      outline-width: 1px;
      outline-offset: 1px;
    }

    .city-input_wrap {
      position: relative;
    }

    .city-list {
      margin: 0;
      padding: 0;
      width: 100%;
      table-layout: auto;
    }

    .city-link {
      cursor: pointer;
      padding: 2px;
      background: #fff;
    }

    .city-active {
      background: #3aa3e3 !important;
      color: #fff !important;
    }

    .city-active td {
      color: #fff !important;
    }

    .city-list td, .city-list th {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #212529;
    }
</style>

<script type="text/javascript">
    export default {
        props: {
            initialize: {
                default: null
            },
            customClass: {
                default: ''
            },
            tabindex: {
                default: 0
            },
            customStyle:{
                default: null
            },
            disabled: {
                type: Boolean,
            },
            district_ids: {
                type: Array,
                default:[]
            }
        },
        data () {
            return {
                timer:null,
                selectIndex: -1,
                isOpen: false,
                search: '',
                results: [],
                loading: false,
                hasMore: true,
                lastPage: 1,
                query: {
                    search: '',
                    order_by: "asc",
                    keyword: "school_name",
                    per_page: 20,
                    page: 1,
                    district_id: "",
                },
                temp:[],
            }
        },
        computed: {
            selectedText() {
                return this.initialize 
                    ? this.initialize
                    : 'Select School'
            }
        },
        methods: {
            focus: function () {
                this.$refs.toggle.focus()
            },

            onToggle() {
                if(this.isOpen) {
                    this.isOpen = false
                } else {
                    this.open()
                }
            },
            onKey(e) {
                const KeyCode = e.KeyCode || e.which
                if(!e.shiftKey && KeyCode !== 9 && !this.isOpen) {
                    this.open()
                }
            },
            open() {
                this.search = ''
                this.fetchData('', { reset: true })
                this.isOpen = true
                this.$nextTick(() => {
                    this.$refs.search.focus()
                })
            },
            buildPayload() {
                const districtId = Array.isArray(this.district_ids) && this.district_ids.length
                    ? this.district_ids[0]
                    : "";
                return {
                    search: this.query.search,
                    order_by: this.query.order_by,
                    keyword: this.query.keyword,
                    per_page: this.query.per_page,
                    page: this.query.page,
                    ...(districtId ? { district_id: districtId } : {}),
                };
            },
            fetchData(searchText, { reset = true, append = false } = {}) {
                let vm = this;
                if (append && (vm.loading || !vm.hasMore)) {
                    return;
                }
                if (vm.timer) {
                    clearTimeout(vm.timer);
                    vm.timer = null;
                }

                const runFetch = () => {
                    if (reset) {
                        vm.query.page = 1;
                        vm.results = [];
                        vm.hasMore = true;
                        vm.lastPage = 1;
                    }
                    vm.query.search = searchText;
                    vm.loading = true;
                    vm.$store.dispatch('post', {
                        uri: 'school/paginateSchool',
                        data: vm.buildPayload(),
                    })
                    .then(function (response) {
                        const rows = response?.data?.data?.data || [];
                        const meta = response?.data?.data?.meta || {};
                        vm.results = append ? vm.results.concat(rows) : rows;
                        vm.lastPage = Number(meta.lastPage) || 1;
                        vm.hasMore = vm.query.page < vm.lastPage;
                    })
                    .catch(function () {
                        if (!append) {
                            vm.results = [];
                        }
                        vm.hasMore = false;
                    })
                    .finally(function () {
                        vm.loading = false;
                    });
                };

                if (append) {
                    runFetch();
                    return;
                }

                vm.timer = setTimeout(runFetch, 250);
            },
            loadMore() {
                if (this.loading || !this.hasMore) {
                    return;
                }
                this.query.page += 1;
                this.fetchData(this.query.search, { reset: false, append: true });
            },
            onResultsScroll(e) {
                const el = e.target;
                if (!el) {
                    return;
                }
                if (el.scrollTop + el.clientHeight >= el.scrollHeight - 48) {
                    this.loadMore();
                }
            },
            onBlur() {
                this.close()
            },
            onEsc() {
                this.close()
            },
            close() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.results = []
                this.isOpen = false
                this.search = ''
                this.selectIndex = -1
                this.loading = false
                this.hasMore = true
                this.lastPage = 1
                this.query.page = 1
                this.query.search = ''
            },
            onSearch(e) {
                const q = e.target.value
                this.search = q
                this.selectIndex = 0
                this.fetchData(q, { reset: true })
            },
            onUpKey() {
                if(this.selectIndex > 0) {
                    this.selectIndex--
                }
            },
            onDownKey() {
                if(this.results.length - 1 > this.selectIndex) {
                    this.selectIndex++
                }
            },
            onEnterKey() {
                const found = this.results[this.selectIndex]
                if(found) {
                    this.select(found)
                }
            },
            schoolLabel(school) {
                const name = String(school?.school_name || "").trim();
                if (name) {
                    return name;
                }
                const address = String(school?.address || "").trim();
                if (address) {
                    return address;
                }
                const place = String(school?.place || "").trim();
                if (place) {
                    return place;
                }
                return school?.school_id ? `School #${school.school_id}` : "Unnamed school";
            },
            select(result) {
                const labeled = {
                    ...result,
                    school_name: this.schoolLabel(result),
                };
                this.$emit('selectSchool', {
                    target: {
                        value: labeled
                    }
                })
                this.close()
            },
            onMouse(index) {
                this.selectIndex = index
            }
         }
    }
</script>